module.exports = __webpack_public_path__ + "img/1505705708.2b9a5af3.jpg";